import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { useRef, useState } from 'react';
import Section from '../shared/Section/Section';
import Container from '../shared/Container/Container';
import ProductCard from '../shared/ProductCard/ProductCard';
import NotifyMeModal from '../shared/NotifyMeModal/NotifyMeModal';
import { products } from '../../data/products';
import './HomeBBQ.css';

const HomeBBQ = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '-100px' });
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleEvalClick = () => {
    window.dispatchEvent(new CustomEvent('toggle-eval'));
  };

  return (
    <>
      <Section background="beige" id="home-bbq">
        <Container>
          <div className="home-bbq" ref={ref}>
            <div className="home-bbq__content">
              <motion.div
                className="home-bbq__text"
                initial={{ opacity: 0, x: -50 }}
                animate={isInView ? { opacity: 1, x: 0 } : {}}
                transition={{ duration: 0.8 }}
              >
                <h2 className="home-bbq__title">
                  Premium Ceramic BBQ Sauce Cup - Gift-Ready Edition
                </h2>

                {products.ceramic && (
                  <ProductCard
                    product={products.ceramic}
                    onNotifyClick={() => setIsModalOpen(true)}
                    variant="ceramic"
                    inView={isInView}
                  />
                )}

                <motion.div
                  className="home-bbq__eval"
                  initial={{ opacity: 0 }}
                  animate={isInView ? { opacity: 1 } : {}}
                  transition={{ duration: 0.6, delay: 0.8 }}
                >
                  <button
                    className="home-bbq__eval-link"
                    onClick={handleEvalClick}
                  >
                    rib-n-dip: the last eval frontier &darr;
                  </button>
                </motion.div>
              </motion.div>

              <motion.div
                className="home-bbq__image"
                initial={{ opacity: 0, x: 50 }}
                animate={isInView ? { opacity: 1, x: 0 } : {}}
                transition={{ duration: 0.8, delay: 0.2 }}
              >
                {/* Image: ceramic_home_edition.jpg */}
                {/* Prompt: A glossy ceramic rib-shaped sauce cup on a picnic table with a grill in the background, warm sunlight, a hand dipping a rib, summer backyard vibe. */}
                <div className="home-bbq__image-wrapper">
                  <div className="home-bbq__badge">CERAMIC EDITION</div>
                  <img
                    src="/images/ceramic_home_edition.jpg"
                    alt="Premium ceramic Rib-n-Dip BBQ sauce cup for home grilling - dishwasher safe elongated rib dipper"
                    className="home-bbq__image-main"
                    loading="lazy"
                  />
                </div>
              </motion.div>
            </div>
          </div>
        </Container>
      </Section>

      {products.ceramic && (
        <NotifyMeModal
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          productName={products.ceramic.name}
          productId={products.ceramic.id}
        />
      )}
    </>
  );
};

export default HomeBBQ;
